import { tree } from '@antv/vendor/d3-hierarchy';
import { hierarchyFunction } from './cluster';
export const Tree = (options) => {
    return hierarchyFunction(tree)(options);
};
Tree.props = {};
//# sourceMappingURL=tree.js.map